import toast, { Toaster as RHTToaster } from 'react-hot-toast'
import { Html } from '../Html'
import { Icon } from '../Icon'
import { tm } from '../tm'
import type {
  Toast as RHTToast,
  ToastOptions as RHTToastOptions,
  ToastPosition as RHTToastPosition,
} from 'react-hot-toast'
import './Toaster.css'

const DEFAULT_TOASTER_OPTIONS: RHTToastOptions = { duration: 8000 }

interface RHTToasterProps {
  position?: RHTToastPosition
  options?: RHTToastOptions
}

const emptyObject = {}
export function ToastContainer({
  position = 'top-right',
  options = emptyObject,
}: RHTToasterProps) {
  return (
    <RHTToaster
      position={position}
      toastOptions={{ ...DEFAULT_TOASTER_OPTIONS, ...options }}
    />
  )
}

interface ToastProps extends Partial<RHTToast> {
  message: string
  className?: string
}

export function ToastError({
  id,
  message,
  visible,
  className = '',
}: ToastProps) {
  return (
    <div
      id={id}
      data-testid={id}
      className={tm(
        'flex min-w-[300px] max-w-[300px] items-center rounded-md border border-dark-red bg-light-red p-3 shadow-lg lg:min-w-[600px] lg:max-w-[600px]',
        visible ? 'toast-in-animation' : 'toast-out-animation',
        className,
      )}
    >
      <Icon icon="warning-round" fill="fill-dark-red" />
      <Html className="text-md ml-3 text-dark-red">{message}</Html>
    </div>
  )
}

export function ToastSuccess({ id, message, visible }: ToastProps) {
  return (
    <div
      id={id}
      data-testid={id}
      className={tm(
        'flex min-w-[300px] max-w-[300px] items-center rounded-md border border-dark-green bg-light-green p-3 shadow-lg',
        visible ? 'toast-in-animation' : 'toast-out-animation',
      )}
    >
      <Icon icon="check-round" fill="fill-dark-green" />
      <Html className="text-md ml-3 text-dark-green">{message}</Html>
    </div>
  )
}

type ToastType = 'success' | 'error'

interface ToasterProps {
  id?: string
  message: string
  type: ToastType
}

const VARIANTS: Record<ToastType, (props: ToastProps) => JSX.Element> = {
  success: ToastSuccess,
  error: ToastError,
}

export const Toaster = ({ id = '', message, type }: ToasterProps) => {
  const Toast = VARIANTS[type]

  return toast.custom(t => <Toast {...t} message={message} />, {
    id,
  })
}
